import React from 'react';
import PropTypes from 'prop-types';
import { setNotification } from '../../helpers/notification';

export default function PriceInput(props) {
  let {
    type,
    label,
    suffixIcon,
    onChange,
    acceptDecimal,
    error,
    placeholder,
    name,
    value,
    disabled,
    ...args
  } = props;

  const change = (e) => {
    if (type === 'number' && (args.max || args.min)) {
      // silinmeye çalışılıyorsa kontrolü
      if (e.target.value !== '') {
        if (e.target.value > args.max) {
          e.target.value = args.max;
          onChange(e);
          return;
        }
      }
    }
    onChange(e);
  };

  const validate = (e) => {
    if (type === 'number' && args.min) {
      // silinmeye çalışılıyorsa kontrolü
      if (e.target.value !== '') {
        if (e.target.value < args.min) {
          e.target.value = args.min;
          setNotification(
            'error',
            `${label ? label + ' için ' : ''}Minimum ${
              args.min
            } girebilirsiniz.`
          );
          onChange(e);
          return;
        }
      }
    }
  };
  const validateKeyDown = (e) => {
    if (
      !(e.which >= 48 && e.which <= 57) &&
      !(e.which >= 96 && e.which <= 105) &&
      e.which !== 8 &&
      e.which !== 190 &&
      e.which !== 37 &&
      e.which !== 39
    ) {
      // 48-57 for 0-9 numbers
      // 96-105 for 0-9 numpad numbers
      // 37-39 for forward and backward buttons
      // 190 for dot
      // 8 for backspace
      e.preventDefault();
    }
  };
  const validateKeyUp = (e) => {
    value = e.target.value;
    if (value && value.includes('.') && e.which !== 8) {
      const [int, decimals] = value.split('.');
      const trimmedDecimals = decimals ? decimals.slice(0, 2) : '';
      e.target.value = `${int}.${trimmedDecimals}`;
      onChange(e);
    }
  };
  return (
    <div
      className='km__c--input-container'
      style={type === 'month' ? { position: 'unset' } : {}}
    >
      {label ? <label>{label}</label> : null}
      <input
        className={`km__c--input ${suffixIcon ? 'km__c--input-has-icon' : ''} ${
          error ? 'km__c--input-has-error' : ''
        }`}
        type='text'
        onChange={change}
        onBlur={validate}
        onKeyDown={validateKeyDown}
        onKeyUp={validateKeyUp}
        placeholder={placeholder}
        name={name}
        value={value}
        disabled={disabled}
        {...args}
      />
    </div>
  );
}

PriceInput.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
};
PriceInput.defaultProps = {
  type: 'text',
};
